import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItemText,
  ListItem,
} from '@material-ui/core';
import { vendors } from './iab-tcf';
import { ExpandMore } from '@material-ui/icons';

function VendorCheckbox({ vendorId, cookieKey, isChecked, onChange }) {
  const vendor = vendors.getIABVendorById(vendorId);

  if (!vendor) {
    return null;
  }

  const altNames = Array.isArray(vendor.altNames) ? ` (${vendor.altNames.join(', ')})` : '';

  return (
    <Box mb={2}>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            data-test-id={`checkbox-vendor-${vendorId}`}
            onChange={() => onChange({ vendorId, cookieKey })}
          />
        }
        label={
          <Typography variant="body1" component="span">
            {vendor.name}{' '}
            <Typography variant="body2" component="span">
              {altNames}
            </Typography>
          </Typography>
        }
      />

      {/* vendor missing */}
      {!vendor.ui.iabVendorFound && (
        <Typography variant="body2" color="error">
          IAB Vendor details not found in GVL. Check GVL the <code>vendor.deletedDate</code>.
        </Typography>
      )}

      {/* purposes */}
      {vendor.ui.iabVendorFound && Array.isArray(vendor.ui.purposes) && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`vendor-purposes-${vendorId}`}
            id={`vendor-purposes-${vendorId}`}
          >
            <Typography component="span" variant="body1" color="textSecondary">
              Purposes - {vendor.ui.purposes.length}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense={true} disablePadding={true}>
              {vendor.ui.purposes.map(purpose => (
                <ListItem key={purpose.id} dense={true}>
                  <ListItemText primary={purpose.name} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      )}

      {/* legitimate interest purposes */}
      {vendor.ui.iabVendorFound && Array.isArray(vendor.ui.legIntPurposes) && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`vendor-legIntPurposes-${vendorId}`}
            id={`vendor-legIntPurposes-${vendorId}`}
          >
            <Typography component="span" variant="body1" color="textSecondary">
              Legitimate Interest Purposes - {vendor.ui.legIntPurposes.length}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense={true} disablePadding={true}>
              {vendor.ui.legIntPurposes.map(purpose => (
                <ListItem key={purpose.id} dense={true}>
                  <ListItemText primary={purpose.name} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      )}

      {/* features */}
      {vendor.ui.iabVendorFound && Array.isArray(vendor.ui.features) && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`vendor-features-${vendorId}`}
            id={`vendor-features-${vendorId}`}
          >
            <Typography component="span" variant="body1" color="textSecondary">
              Features - {vendor.ui.features.length}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense={true} disablePadding={true}>
              {vendor.ui.features.map(purpose => (
                <ListItem key={purpose.id} dense={true}>
                  <ListItemText primary={purpose.name} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      )}

      {/* special features */}
      {vendor.ui.iabVendorFound && Array.isArray(vendor.ui.specialFeatures) && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`vendor-legIntPurposes-${vendorId}`}
            id={`vendor-legIntPurposes-${vendorId}`}
          >
            <Typography component="span" variant="body1" color="textSecondary">
              Special Features - {vendor.ui.specialFeatures.length}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense={true} disablePadding={true}>
              {vendor.ui.specialFeatures.map(purpose => (
                <ListItem key={purpose.id} dense={true}>
                  <ListItemText primary={purpose.name} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
}

VendorCheckbox.propTypes = {
  vendorId: PropTypes.number.isRequired,
  cookieKey: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default VendorCheckbox;
